import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';

import {CONFIG} from 'src/global-config';

import {LoadingScreen} from 'src/components/loading-screen';

import {AuthGuard, RoleBasedGuard} from 'src/auth/guard';

import { usePathname } from '../hooks';
import { DashboardLayout } from "../../layouts/dashboard";
import { BillingLayout } from "../../sections/billing/billing-layout";

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/billing/subscription'));


const BillingSubscriptionPage = lazy(() => import('src/pages/billing/subscription'));
const BillingInvoicesPage = lazy(() => import('src/pages/billing/invoices'));
const BillingConsumptionPage = lazy(() => import('src/pages/billing/consumption'));


// ----------------------------------------------------------------------

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const layoutContent = () => (
  <BillingLayout>
    <SuspenseOutlet />
  </BillingLayout>
);

export const billingRoutes = [
  {
    path: 'billing',
    element: CONFIG.auth.skip ? layoutContent() : (
      <AuthGuard>
        <DashboardLayout>
          <RoleBasedGuard acceptRoles={['admin', 'operator']} hasContent>
            {layoutContent()}
          </RoleBasedGuard>
        </DashboardLayout>
      </AuthGuard>),
    children: [
      {element: <IndexPage/>, index: true},
      {path: 'subscription', element: <BillingSubscriptionPage/>, index: true},
      {path: 'invoices', element: <BillingInvoicesPage/>, index: true},
      {path: 'consumption', element: <BillingConsumptionPage/>, index: true},
    ],
  },
];
